import React, { useState } from 'react'
import { Box, IconButton, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AddIcon from '@mui/icons-material/Add';
import Tab from './Tab';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import { useDispatch, useSelector } from 'react-redux';
import { addTab, removePanel, removeTab, setActivePanel, setActiveTab, addPanel } from '../../../features/tabs/tabsSlice';
import Boards from './Boards';
const Tabs = () => {
  const { meetingStarted } = useSelector((store) => store.meeting)
  const dispatch = useDispatch();
  const { tabs } = useSelector((store) => store.tabs)
  const { t } = useTranslation();
  const [tabsMaxLenghtReached, setTabsMaxLengthReached] = useState(false);
  const handleCloseTab = (id) => {
    dispatch(removeTab({ id }))
    dispatch(removePanel({ id }))
    setTabsMaxLengthReached(false)
    handelActiveTab(1)
  }
  const handleAddTab = () => {
    const newId = tabs[tabs.length - 1].id + 1;

    const tabsCount = tabs.length + 1
    if (tabsCount <= 8) {
      dispatch(addTab({ tab: { id: newId, title: t("board") + " " + newId, closable: true, active: true } }))
      dispatch(addPanel({ panel: { id: newId, active: false, path: false } }))
      handelActiveTab(newId);
    } else {
      setTabsMaxLengthReached(true)
    }

  }
  const handelActiveTab = (id) => {
    dispatch(setActiveTab({ id }))
    dispatch(setActivePanel({ id }))
  }

  const handleCloseAlert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setTabsMaxLengthReached(false);
  }
  const TabsBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '5px',
    backgroundColor: theme.palette.background.gray
  }))
  const PanelBox = styled(Box)(({ theme }) => ({
    width: '100%',
    height: '100%'
  }))
  const TabPanelContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    flex: 10
  }))
  const BoardContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    flex: 20
  }))

  return (
    <BoardContainer >

      <TabPanelContainer>
        <Snackbar
          open={tabsMaxLenghtReached}
          autoHideDuration={3000}
          onClose={() => setTabsMaxLengthReached(false)}
          message={t("noMoreTabs")}
          action={<Button color="primary" size="small" onClick={handleCloseAlert} sx={{ m: '0px 20px' }}
          >
            {t("ok")}
          </Button>}

        />
        <TabsBox style={{ display: 'flex' }}>
          {tabs.map(tab => (
            <Tab key={tab.id} data={tab} onClose={(id) => handleCloseTab(id)} onActive={(id) => handelActiveTab(id)} />
          ))}
          <IconButton onClick={() => handleAddTab()}>
            <AddIcon />
          </IconButton>
        </TabsBox>
        <PanelBox>
          <Boards />
        </PanelBox>
      </TabPanelContainer>
    </BoardContainer>


  )
}

export default Tabs